// extracted by mini-css-extract-plugin
module.exports = {"root":"_114c26","isFullWidth":"_c615df"};